import React from "react";
import MenuBar from "./Menu/MenuBar.js";
import HeroSection from "./Hero/HeroSection.js";
import NewsSection from "./News/NewsSection.js";
import WidgetsSection from "./Widgets/WidgetsSection.js";
import AppPromoBanner from "./Promo/AppPromoBanner.js";
import FooterSection from "./Footer/FooterSection.js";

const App: React.FC = () => {
  return (
    <div className="min-h-screen bg-nearblack-500">
      <MenuBar className="bg-nearblack-500 text-gray-400" />

      <HeroSection />

      <div className="background-image">
        <NewsSection />
        <WidgetsSection />
      </div>

      <AppPromoBanner />

      <FooterSection />
    </div>
  );
};

export default App;
